export default "__VITE_ASSET__790e5324__"